// rectype for autocode dictionary tree
export const RLD_RECTYPE_Q = 'Q';
export const RLD_RECTYPE_T = 'T';
export const RLD_RECTYPE_S = 'S';

// Parent and child category label separator
export const PARENT_CHILDREN_LABEL_SEPARATOR = ' / ';
export const RLD_IS_DICTIONARY_ONLY_LABEL = 'Dictionary File Only';
export const RLD_IS_ALL_LOCAL_MARKETS_LABEL = 'All Local Markets';
export const RLD_LOCAL_MARKETS_IDENTIFIERS = [11, 57, 92, 103, 104];

export const RldConstant = {
  exportFormats: [
    { label: 'CSV File Format', value: 1 },
    { label: 'TSV File Format', value: 2 },
    { label: 'Fixed Length File Format', value: 3 },
  ],
  dictionaryFormats: [
    { label: 'Flat Structure', value: 1 },
    { label: 'Hierarchical Structure', value: 2 },
  ],
  emailDomains: ['gfk.com', 'mrisimmons.com'],
};

export const RLD_FILE_STRUCTURE_FORMATS = [
  { label: 'Long File Format', value: 1 },
  { label: 'Wide File Format', value: 2 },
];

export default RldConstant;

// RLD View Types
export const RLD_VIEW_LIBRARY = 'LIBRARY';
export const RLD_VIEW_NEW_REQUEST = 'NEW_REQUEST';
export const RLD_SEAT_LIMIT_ERROR =
  ' Please remove one or more users assigned to this subscription.';
